(function (angular, schoolwork12) {

    'use strict';

    var courseManagementController = angular.module(schoolwork12.app.manageCourseManagement.name);
    courseManagementController.controller(schoolwork12.app.manageCourseManagement.controllers.addCourse, [
        '$rootScope', '$scope', '$timeout', '$http', '$uibModal', '$location', '$q', '$anchorScroll',
        schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.eventNotification,
        schoolwork12.app.manageCourseManagement.services.courseManagementService,
        function ($rootScope, $scope, $timeout, $http, $uibModal, $location, $q, $anchorScroll,
                  authentication, eventNotification, courseManagementService) {

            $scope.errors = {
                courseCodeRequired: schoolwork12.app.manageCourseManagement.errorMessages.courseCodeRequired,
                courseNameRequired: schoolwork12.app.manageCourseManagement.errorMessages.courseNameRequired,
                defaultCreditsRequired: schoolwork12.app.manageCourseManagement.errorMessages.defaultCreditsRequired,
                courseGradeRequired: schoolwork12.app.manageCourseManagement.errorMessages.courseGradeRequired,
                courseTypeRequired: schoolwork12.app.manageCourseManagement.errorMessages.courseTypeRequired,
                daysPerWeekRequired: schoolwork12.app.manageCourseManagement.errorMessages.daysPerWeekRequired,
                defaultAttendanceRequired: schoolwork12.app.manageCourseManagement.errorMessages.defaultAttendanceRequired,
                maxNumberPrepDaysRequired: schoolwork12.app.manageCourseManagement.errorMessages.maxNumberPrepDaysRequired,
                coursePlatformRequired: schoolwork12.app.manageCourseManagement.errorMessages.coursePlatformRequired,
                contentProviderRequired: schoolwork12.app.manageCourseManagement.errorMessages.contentProviderRequired,
                courseNameMaxLength: schoolwork12.app.manageCourseManagement.errorMessages.courseNameMaxLength,
                abbreviationMaxLength: schoolwork12.app.manageCourseManagement.errorMessages.abbreviationMaxLength,
                daysPerWeekInvalidRange: schoolwork12.app.manageCourseManagement.errorMessages.daysPerWeekInvalidRange,
                nextCourseInvalidValue: schoolwork12.app.manageCourseManagement.errorMessages.nextCourseInvalidValue,
                defaultAttendanceInvalidRange: schoolwork12.app.manageCourseManagement.errorMessages.defaultAttendanceInvalidRange,
                maxNumberPrepInvalidValue: schoolwork12.app.manageCourseManagement.errorMessages.maxNumberPrepInvalidValue,
                courseCodeDuplicated: schoolwork12.app.manageCourseManagement.errorMessages.courseCodeDuplicated,
                courseNameDuplicated: schoolwork12.app.manageCourseManagement.errorMessages.courseNameDuplicated
            };

            $scope.form = {};
            $scope.course = {
                status: 1,
                specifiedStates: [],
                courseVendors: [],
                nextCourses: []
            };
            $scope.hasAdded = false;
            $scope.serverErrors = [];
            $scope.nextCourseText = "";
            $rootScope.hideCourseManagementSearch = true;

            $scope.isSearchBusy = true;
            $rootScope.showSavedSuccessMsg = false;
            $rootScope.showPartialWarningMsg = false;

            $scope.option1 = false;
            $scope.modalInstance1 = null;
            $rootScope.$on('$stateChangeStart', (event, next) => {
                if ($scope.courseForm){
                    if (!$scope.hasAdded && $scope.courseForm.$dirty){
                        if(!$scope.option1){
                            $scope.openAlertUnsaved();
                            event.preventDefault();
                        }
                        $scope.modalInstance1.result.then((option) => {
                            $scope.option1 = option;
                            $location.url(next.url);
                        }, () => {
                        });
                    }
                }
            })
            $scope.openAlertUnsaved = () => {
                $scope.modalInstance1 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    windowClass: "alert-Modal",
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        ($scope, $uibModalInstance) => {
                            $scope.ok = () => {
                                $uibModalInstance.close(true);
                            };
                            $scope.dialogMsg = 'You have unsaved changes for the current screen. Do you want to continue without saving the course?';
                            $scope.cancel = () => {
                                $uibModalInstance.dismiss('cancel');
                            };
                        }],
                });
            };


            const doExtraValidations = () => {
                $scope.courseForm.daysPerWeek.$validate();
                $scope.courseForm.defaultAttendanceMinutes.$validate();
                $scope.courseForm.maxNumberPrepDays.$validate();
                $scope.courseForm.platform.$validate();
                $scope.courseForm.contentProvider.$validate();
                $scope.courseForm.nextCourses.$setValidity('invalidValue', !$scope.nextCourseText);
            }

            const isD2LCourse = () => {
                const courseTypes = [3, 4, 5, 6, 10, 7];
                if ($scope.course.courseTypeObject && courseTypes.includes($scope.course.courseTypeObject.id))
                    return true;
                return false;
            }

            const isAttendanceOnly = () => {
                if ($scope.course.courseContentType && $scope.course.courseContentType.courseContentId === 1)
                    return true;
                return false;
            }

            const showNotification = () => {
                $rootScope.showSavedSuccessMsg = true;

                $timeout(() => {
                    $rootScope.showSavedSuccessMsg = false;
                }, 5000);
            }

            const showNotificationError = (message) => {
                $rootScope.showSavedErrorMsg = true;
                $rootScope.errors = message;
                $timeout(() => {
                    $rootScope.showSavedErrorMsg = false;
                }, 5000);
            }
            const validateForm = () => {
                $scope.server = [];
                $scope.courseForm.$setSubmitted();
                doExtraValidations();
                return $scope.courseForm.$valid;
            }

            $scope.getFindCoursesDataForm = function () {
                var courseDropDownDetailsPromise = null;
                var getCourseDropDownDetails = function () {
                    courseDropDownDetailsPromise = courseManagementService.getCourseDropDownDetails(authentication.getCurrentUser().keycode);
                    courseDropDownDetailsPromise.then(function (data) {
                        $scope.items = data;
                        $scope.isSearchBusy = false;
                    }, function (error) {
                        $scope.addCourseErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.addCourseErrorMesg = $scope.addCourseErrorMesg + error.data._errors[j] + "\n" + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.addCourseErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.addCourseErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    });
                };
                getCourseDropDownDetails();
            };
            $scope.getFindCoursesDataForm();

            $scope.allTagsAdded = [];
            $scope.nextCoursesList = [];
            $scope.nextCourse = {};
            $scope.nextCourse.nextCourseId = 0;

            $scope.loadTags = function ($query) {

                $query = $query.trim();
                var defer = $q.defer();
                courseManagementService.nextCourseListByCode(authentication.getCurrentUser().keycode, $query).then(function (data, status, headers, config) {
                        $scope.allTagsAdded = data;


                        var matchingTags = data;
                        if ($query.length >= $scope.minAutocompleteSize) {
                            matchingTags = matchingTags.filter(function (item) {
                                return item.nextCourseCode.toLowerCase().indexOf($query.toLowerCase()) != -1;
                            });
                            if (matchingTags.length <= 0) {
                                matchingTags = [{
                                    "name": "Oops, nothing found! " + "'" + $query + "'"
                                }];
                            }
                            if (matchingTags.length > 1) {
                                matchingTags = [matchingTags[0]];
                            }
                        }
                        defer.resolve($scope.allTagsAdded);
                    });
                return defer.promise;
            };
            $scope.removeDuplicatesTags = function (tagsArray) {
                for (var i = 0, len = $scope.allTagsAdded.length; i < len; i++) {
                    for (var j = 0, length = tagsArray.length; j < length; j++) {
                        if (tagsArray[j].nextCourseCode.toLowerCase() == $scope.allTagsAdded[i].nextCourseCode.toLowerCase()) {
                            tagsArray.splice(j, 1);
                            break;
                        }
                    }
                }
                return tagsArray;
            };

            $scope.tagAdded = function (tag) {
                $scope.allTagsAdded.push(tag);
            };

            $scope.tagRemoved = function (tag) {
                $scope.allTagsAdded = $scope.allTagsAdded.filter(function (item) {
                    return item.nextCourseCode.toLowerCase() !== tag.nextCourseCode.toLowerCase();
                });
            };

            $scope.addCourse = () => {
                if (validateForm()) {
                    $scope.isSearchBusy = true;
                    courseManagementService.addCourse(authentication.getCurrentUser().keycode, $scope.course)
                        .then(() => {
                            $scope.hasAdded = true;
                            showNotification();
                            $location.url(schoolwork12.app.manageCourseManagement.routes.courseManagement);
                        })
                        .catch(({data}) => {
                            showNotificationError(data);
                        })
                        .finally(()=>{
                            $scope.isSearchBusy = false;
                        });
                }
            }

            $scope.hasError = (error) => {
                return $scope.courseForm.$submitted && error;
            }

            $scope.isCurric = () => {
                if (isD2LCourse())
                    return true;

                if ($scope.course.courseContentType && $scope.course.courseContentType.courseContentId === 1)
                    return true;

                // EXTRA VALIDATION

                return false;
            }

            $scope.changeCourseType = () => {
                if (isD2LCourse()){
                    if (!$scope.course.numDaysWeekIdeal)
                        $scope.course.numDaysWeekIdeal = 5;
                    if (!$scope.course.defaultAttendanceMins)
                        $scope.course.defaultAttendanceMins = 60;
                    if (!$scope.course.maxAdvPrepDays)
                        $scope.course.maxAdvPrepDays = 1;
                    if (!$scope.course.platformId)
                        $scope.course.platformId = 5;
                    if (!$scope.course.contentProviderCode)
                        $scope.course.contentProviderCode =2;
                }
            }

            $scope.changeContentType = () => {
                if (isAttendanceOnly()){
                    if (!$scope.course.numDaysWeekIdeal)
                        $scope.course.numDaysWeekIdeal = 5;
                    if (!$scope.course.defaultAttendanceMins)
                        $scope.course.defaultAttendanceMins = 60;
                    if (!$scope.course.maxAdvPrepDays)
                        $scope.course.maxAdvPrepDays = 1;
                    if (!$scope.course.platformId)
                        $scope.course.platformId = 5;
                    if (!$scope.course.contentProviderCode)
                        $scope.course.contentProviderCode =2;
                }
            }

            $scope.wasModified = () => {
                if  ($scope.courseForm && $scope.courseForm.$dirty)
                    return true;
                return false;
            }
        }]);


    courseManagementController.directive('curricRequired', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.curricRequired = function (modelValue, viewValue) {

                    // if (!attrs.disabled && scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                    if (scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                        return false;
                    }
                    return true;
                };
            }
        };
    });

    courseManagementController.directive('daysPerWeek', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.curricRequired = function (modelValue, viewValue) {

                    // if (!attrs.disabled && scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                    if (scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                        return false;
                    }
                    return true;
                };
                ctrl.$validators.daysPerWeekInvalidRange = (modelValue, viewValue) => {
                    if (0 < parseInt(modelValue) && parseInt(modelValue) > 8) {
                        return false;
                    }
                    return true;
                }
            }
        };
    });

    courseManagementController.directive('defaultAttendanceMinutes', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.curricRequired = function (modelValue, viewValue) {

                    // if (!attrs.disabled && scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                    if (scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                        return false;
                    }
                    return true;
                };
                ctrl.$validators.defaultAttendanceMinutesInvalidRange = (modelValue, viewValue) => {
                    if (0 < parseInt(modelValue) && parseInt(modelValue) > 120) {
                        return false;
                    }
                    return true;
                }
            }
        };
    });

    courseManagementController.directive('maxPrepDays', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.curricRequired = function (modelValue, viewValue) {

                    // if (!attrs.disabled && scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                    if (scope.isCurric() && ctrl.$isEmpty(modelValue)) {
                        return false;
                    }
                    return true;
                };
                ctrl.$validators.maxNumberOfPrepDaysInvalidRange = (modelValue, viewValue) => {
                    if (0 < parseInt(modelValue) && parseInt(modelValue) > 21) {
                        return false;
                    }
                    return true;
                }
            }
        };
    });

    courseManagementController.directive('onlyNumbers', () => {
        return {
            require: 'ngModel',
            link: (scope, element, attr, ngModelCtrl) => {
                ngModelCtrl.$parsers.push((text) => {
                    const transformedInput = text.replace(/[^0-9]/g, '');
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };
    });

}(angular, schoolwork12));
